import { render, staticRenderFns } from "./OpencartKategori.vue?vue&type=template&id=6243a9a8&scoped=true"
import script from "./OpencartKategori.vue?vue&type=script&lang=js"
export * from "./OpencartKategori.vue?vue&type=script&lang=js"
import style0 from "./OpencartKategori.vue?vue&type=style&index=0&id=6243a9a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243a9a8",
  null
  
)

export default component.exports